var map = {
	"./au/client.routes.json": 1292,
	"./be/client.routes.json": 3971,
	"./ca/client.routes.json": 2701,
	"./core/client.routes.json": 9257,
	"./de/client.routes.json": 7373,
	"./fr/client.routes.json": 7986,
	"./nz/client.routes.json": 194,
	"./sg/client.routes.json": 1556,
	"./sph/client.routes.json": 819,
	"./uk/client.routes.json": 1094,
	"./us/client.routes.json": 3134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6489;